

































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ProductServerDuration } from '../../../store/product/types';

@Component
export default class CheckoutContractDurationItem extends Vue {
  name = 'CheckoutContractDurationItem';

  @Prop({ type: Object }) readonly contractDuration: ProductServerDuration;

  @Prop({ type: Object }) readonly selectedContractDuration: ProductServerDuration;
}
